(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



/**
 *  Read More JS
 *  Truncates text via specfied character length with more/less actions.
 *  Maintains original format of pre truncated text.
 *  @author stephen scaff
 *  @todo   Add destroy method for ajaxed content support.
 *
 */
//  const ReadMore = (() => {
//    let s;

//    return {

//      settings() {
//        return {
//          content: document.querySelectorAll('.js-read-more'),
//          originalContentArr: [],
//          truncatedContentArr: [],
//          moreLink: "Read More",
//          lessLink: "Read Less",
//        }
//      },

//      init() {
//        s = this.settings();
//        this.bindEvents();
//      },

//      bindEvents() {
//        ReadMore.truncateText();
//      },

//      /**
//       * Count Words
//       * Helper to handle word count.
//       * @param {string} str - Target content string.
//       */
//      countWords(str) {
//        return str.split(/\s+/).length;
//      },

//      /**
//       * Ellpise Content
//       * @param {string} str - content string.
//       * @param {number} wordsNum - Number of words to show before truncation.
//       */
//      ellipseContent(str, wordsNum) {
//        return str.split(/\s+/).slice(0, wordsNum).join(' ') + '...';
//      },

//      /**
//       * Truncate Text
//       * Truncate and ellipses contented content
//       * based on specified word count.
//       * Calls createLink() and handleClick() methods.
//       */
//      truncateText() {

//        for (let i = 0; i < s.content.length; i++) {
//          //console.log(s.content)
//          const originalContent = s.content[i].innerHTML;
//          const numberOfWords = s.content[i].dataset.rmWords;
//          const truncateContent = ReadMore.ellipseContent(originalContent, numberOfWords);
//          const originalContentWords = ReadMore.countWords(originalContent);

//          s.originalContentArr.push(originalContent);
//          s.truncatedContentArr.push(truncateContent);

//          if (numberOfWords < originalContentWords) {
//            s.content[i].innerHTML = s.truncatedContentArr[i];
//            let self = i;
//            ReadMore.createLink(self)
//          }
//        }
//        ReadMore.handleClick(s.content);
//      },

//      /**
//       * Create Link
//       * Creates and Inserts Read More Link
//       * @param {number} index - index reference of looped item
//       */
//      createLink(index) {
//        const linkWrap = document.createElement('span');

//        linkWrap.className = 'read-more__link-wrap';

//        linkWrap.innerHTML = `<a id="read-more_${index}" class="read-more__link" style="cursor:pointer;">${s.moreLink}</a>`;

//        // Inset created link
//        s.content[index].parentNode.insertBefore(linkWrap, s.content[index].nextSibling);

//      },

//      /**
//       * Handle Click
//       * Toggle Click eve
//       */
//      handleClick(el) {
//        const readMoreLink = document.querySelectorAll('.read-more__link');

//        for (let j = 0, l = readMoreLink.length; j < l; j++) {

//          readMoreLink[j].addEventListener('click', function() {

//            const moreLinkID = this.getAttribute('id');
//            let index = moreLinkID.split('_')[1];

//            el[index].classList.toggle('is-expanded');

//            if (this.dataset.clicked !== 'true') {
//               el[index].innerHTML = s.originalContentArr[index];
//               this.innerHTML = s.lessLink;
//               this.dataset.clicked = true;
//            } else {
//              el[index].innerHTML = s.truncatedContentArr[index];
//              this.innerHTML = s.moreLink;
//              this.dataset.clicked = false;
//            }
//          });
//        }
//      },

//      /**
//       * Open All
//       * Method to expand all instances on the page.
//       */
//      openAll() {
//        const instances = document.querySelectorAll('.read-more__link');
//          for (let i = 0; i < instances.length; i++) {
//            content[i].innerHTML = s.truncatedContentArr[i];
//            instances[i].innerHTML = s.moreLink;
//          }
//        }
//      }
//  })();

// ReadMore.init()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !window.DesignMode) return;
  try {
    
  lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true,
      'fadeDuration' : 300,
      'imageFadeDuration' : 300
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-details"] && !window.DesignMode) return;
  try {
    
  document.querySelectorAll(".offer-section .offer-inner .offer-box .offer-code").forEach(function(copyBtn) {
   copyBtn.addEventListener("click", function() {
    var thisOffer = copyBtn.closest('.offer-box');
    
    document.querySelectorAll(".offer-section .offer-inner .offer-code .offer-box").forEach(function(box) {
      box.classList.remove('active');
    });
    
    var input = copyBtn.querySelector('input');
    input.select();
    document.execCommand("copy");

    thisOffer.classList.add('active');
    
    setTimeout(function() {
      thisOffer.classList.remove('active');
    }, 2000);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-intention"] && !window.DesignMode) return;
  try {
    
jQuery('.shop-by-intention .collection__title').click(function(){
  jQuery(this).parent().parent().parent().toggleClass('open');
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-image-carousel"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
   let lazyVideos = document.querySelectorAll("video.lazyVideo");

   if ("IntersectionObserver" in window) {
     let lazyVideoObserver = new IntersectionObserver(function(entries) {
       entries.forEach(function(video) {
         if (video.isIntersecting) {
           for (let source in video.target.children) {
             let videoSource = video.target.children[source];
             if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
               videoSource.src = videoSource.dataset.src;
             }
           }

           video.target.load();
           video.target.classList.remove("lazyVideo");
           lazyVideoObserver.unobserve(video.target);
         }
       });
     });

     lazyVideos.forEach(function(lazyVideo) {
       lazyVideoObserver.observe(lazyVideo);
     });
   }
  });

  } catch(e) { console.error(e); }
})();
})();
